import $ from 'jquery';
import { Model } from 'backbone';
import BasePropertyView from 'BasePropertyView';
import Immutable from 'immutable';
import ListService from 'ListService';
import contentTemplate from 'behaviors/properties/main/notify/edit-notification-time.ejs';
import selectFieldModal from 'common-views/SelectFieldModalView';
import Constants from 'Constants.js'
import formulaModal from 'common-views/MainFormulaModalView';
import constants from 'Constants';
import _ from 'lodash';


class EditNotificationTimeView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = '#editNotificationTime';
        this.factoryKey = opts.factoryKey;
        this.table = Constants.PROP_MAIN_TABLE_NOTIFICATION_VIEW;
        this.model.set('notificationTimeArray', ['Now', 'On a specific date', 'After a fixed period',
            'After a period taken from a field', 'On a date taken from a field', 'On a date taken from a formula',
            'Until the next stage is reached every'], {silent:true});

        if (this.factoryKey === undefined) {
            this.factoryKey = this.model.attributes.factoryKey;
        }
        if (!this.model.get('activationDate')) {
            this.model.set('activationDate', '', {silent: true})
        }
        if (!this.model.get('activationDateField')) {
            this.model.set('activationDateField', '', {silent: true})
        }
        if (!this.model.get('activationDateFieldName')) {
            this.model.set('activationDateFieldName', '', {silent: true})
        }
        if (!this.model.get('activationPeriodAmountLiteral')) {
            this.model.set('activationPeriodAmountLiteral', '', {silent: true})
        }
        if (!this.model.get('activationPeriodAmountFieldId')) {
            this.model.set('activationPeriodAmountFieldId', '', {silent: true})
            this.model.set('activationPeriodAmountFieldName', '', {silent: true});
        } else {
            // look for the name here, with list service
            let name = ListService.getObject(this.model.get('activationPeriodAmountFieldId'));
            this.model.set('activationPeriodAmountFieldName', name.model.get('name'), {silent: true})
        }
        if (!this.model.get('activationRecurisveEmailNumber')) {
            this.model.set('activationRecurisveEmailNumber', '', {silent: true})
        }

        this.events = {
            'change input[type=text]'           : 'updateAttributes',
            'change input[type=number]'           : 'updateAttributes',
            'blur input[type=text]'             : 'lostFocus',
            'focus input[type=text]'            : 'getFocus',
            'change select'                     : 'updateSelectAttributes',
            'change input[name=activationType]' : 'updateRadioAttributes',
            'change input[name=cancelAllOthers]' : 'updateCheckboxAttributes',
            'click #DateFieldBtn, #PeriodAmountFieldIdBtn'  : 'showValueFieldModal',
            'click #DateExpressionBtn'          : 'showFormulaModal'
        };


        // Don't change this name without realizing that the base class may assume this name
        this.dropdownPropNames = Immutable.List(
            ['activationPeriodUnitLiteral', 'activationPeriodUnitField', 'activationRecurisveEmailFrequency']);


        return this;
    }

    updateCheckboxAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.checked;
        this.model.set(propName, propVal);
        this.updateGrid(propName, propVal);
    }

    updateRadioAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        const propId  = ev.currentTarget.id;

        const activationDate=$('#activationDate');
        const activationDateImg=$('#activationDate ~ img');

        this.resetFields();
        this.activateFields(propName, propVal);
        if ( propId === 'Date') {
            this._injectDatePicker();
            activationDate.datepicker('enable');
            activationDateImg.css('opacity',constants.CSS_CALENDAR_ENABLE);
        }else{
            activationDate.datepicker('disable');
            activationDateImg.css( 'opacity', constants.CSS_CALENDAR_DISABLE);
        }
        this.model.set('activationType', propVal);
        $("input[name="+propName+"][value=" + propVal + "]").prop('checked', true);
        this.updateGrid('activationType', propVal);
    }

    activateFields(propName, val) {
        let propId = $("input[name="+propName+"][value=" + val + "]").attr('id');
        if ( propId !== 'DateExpression' && propId !== 'now') {
            if (propId !== 'DateField' && propId !== 'PeriodAmountFieldId') {
                $('#activation'+propId).attr('readOnly', false);
            }
            $('#activation'+propId).attr('disabled', false);
        }
        if ( propId === 'DateExpression' || propId === 'DateField'
            || propId === 'PeriodAmountFieldId')  {
            $('#'+propId+'Btn').attr('disabled', false);
            $('#'+propId+'Btn').attr('readOnly', false);
        }
        if ( propId === 'PeriodAmountLiteral' ) {
            $('#activationPeriodUnitLiteral').attr('disabled', false);
            $('#activationPeriodUnitLiteral').attr('readOnly', false);
        }
        if ( propId === 'PeriodAmountFieldId') {
            $('#activationPeriodUnitField').attr('disabled', false);
            $('#activationPeriodUnitField').attr('readOnly', false);
        }
        if ( propId === 'RecurisveEmailNumber' ) {
            $('#activationRecurisveEmailFrequency').attr('disabled', false);
            $('#activationRecurisveEmailFrequency').attr('readOnly', false);
        }
        if ( propId === 'Date') {
            $('#activation'+propId).attr('disabled', false);
            $('#activation'+propId).attr('readOnly', false);
            this._injectDatePicker();
            $('#activationDate').datepicker('enable');
            $('#activationDate ~ img').css('opacity',constants.CSS_CALENDAR_ENABLE);

        }else{
            $("#activationDate").datepicker('disable');
            $('#activationDate ~ img').css( 'opacity', constants.CSS_CALENDAR_DISABLE);

        }
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        this.model.set(propName, propVal);
        this.updateGrid(propName, propVal);

        this.checkButton(propName);
    }

    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        this.model.set(propName, propVal);
        this.updateGrid(propName, propVal);

        this.checkButton();
    }

    checkButton(selectedField) {
        const button = $('.ui-dialog-buttonset > .btn-select-field');
        const frequency = $('#activationRecurisveEmailFrequency');
        const recursive = $('#activationRecurisveEmailNumber');
        const validateFrequency = () => frequency.val() === 'minutes' && Number(recursive.val()) < 30;

        button.attr("disabled", false).css('cursor', 'pointer').css('opacity', '');
        if ((selectedField && selectedField === "activationRecurisveEmailNumber" && validateFrequency()) || validateFrequency()) {
            button.attr("disabled", true).css('cursor', 'not-allowed').css('opacity', '0.65');
        }
    }

    showValueFieldModal(ev) {
        ev.preventDefault();
        const buttonName = ev.target.name;
        const fieldName = buttonName.replace('Btn', '');
        var sfModal = new selectFieldModal({model: new Model(),  mode: 'insertField'});
        sfModal.render().then((selectedField)=>{
            // Setting this new property across the Edit Notification Modal so doesnt affect the previous functionality.
            switch(fieldName) {
                case 'PeriodAmountFieldId':
                    this.model.set('activationPeriodAmountFieldId',selectedField.id, {silent : true});
                    this.model.set('activationPeriodAmountFieldName',selectedField.name, {silent : true});
                    this.updateGrid('activationPeriodAmountFieldId', selectedField.id);
                    this.updateGrid('activationPeriodAmountFieldName', selectedField.name);
                    $('#activation'+fieldName).val(selectedField.name);
                break;
                case 'DateField':
                    this.model.set('activationDateField',selectedField.id, {silent : true});
                    this.model.set('activationDateFieldName',selectedField.name, {silent : true});
                    this.updateGrid('activationDateField', selectedField.id);
                    this.updateGrid('activationDateFieldName', selectedField.name);
                    $('#activation'+fieldName).val(selectedField.name);
                break;
                default:
                    this.model.set('activation'+fieldName, selectedField.name + ' ' +  selectedField.id, {silent : true});
                    this.updateGrid('activation'+fieldName, selectedField.name + ' ' +  selectedField.id);
                break;
            }

        }).catch(err => console.log(err));
    }

    showFormulaModal(ev) {
        ev.preventDefault();
        const factoryKey= 'modal';
        const attributes = {formulaParameter: this.model.get('activationDateExpression')};

        var sfModal = new formulaModal({model: new Model(attributes), config: {selected: ''}});
        sfModal.render().then((selectedField)=>{
            selectedField.type = 'scriptingCondition'; //PF-5537, this should be the value always
            this.model.set('activationDateExpression', selectedField, {silent: true});
            this.updateGrid('activationDateExpression', selectedField);
        }).catch(err => console.log(err));
    }

    resetFields() {
        $('#activationDate').attr('disabled', true);
        $('#activationDate').attr('readOnly', true);
        $('#activationDateField').attr('disabled', true);
        $('#activationDateField').attr('readOnly', true);
        $('#DateFieldBtn').attr('disabled', true);
        $('#DateFieldBtn').attr('readOnly', true);
        $('#activationPeriodAmountLiteral').attr('disabled', true);
        $('#activationPeriodAmountLiteral').attr('readOnly', true);
        $('#activationPeriodUnitLiteral').attr('disabled', true);
        $('#activationPeriodUnitLiteral').attr('readOnly', true);
        $('#activationPeriodAmountFieldId').attr('disabled', true);
        $('#activationPeriodAmountFieldId').attr('readOnly', true);
        $('#PeriodAmountFieldIdBtn').attr('disabled', true);
        $('#PeriodAmountFieldIdBtn').attr('readOnly', true);
        $('#activationPeriodUnitField').attr('disabled', true);
        $('#activationPeriodUnitField').attr('readOnly', true);
        $('#DateExpressionBtn').attr('disabled', true);
        $('#DateExpressionBtn').attr('readOnly', true);
        $('#activationRecurisveEmailNumber').attr('disabled', true);
        $('#activationRecurisveEmailNumber').attr('readOnly', true);
        $('#activationRecurisveEmailFrequency').attr('disabled', true);
        $('#activationRecurisveEmailFrequency').attr('readOnly', true);
    }

    updateGrid(field, value) {
        let id = $(this.table).getGridParam('selrow');
        let rowData = $(this.table).getRowData(id);
        rowData[field] = value;
        switch (rowData.activationType) {
            case '0':
                rowData.timeToDisplay = this.model.get('notificationTimeArray')[0];
                break;
            case '1':
                rowData.timeToDisplay = 'On ' + this.model.get('activationDate');
                rowData.activationDate = this.model.get('activationDate');
                break;
            case '2':
                rowData.timeToDisplay = 'After ' + this.model.get('activationPeriodAmountLiteral') + ' ' + _.startCase(this.model.get('activationPeriodUnitLiteral')); //this.model.get('activationPeriodAmountFieldId');
                rowData.activationPeriodAmountLiteral = this.model.get('activationPeriodAmountLiteral');
                rowData.activationPeriodUnitLiteral = this.model.get('activationPeriodUnitLiteral').toLowerCase();
                break;
            case '3':
                rowData.timeToDisplay = 'After a period taken from field ' + this.model.get('activationPeriodAmountFieldName');
                rowData.activationPeriodAmountFieldId = this.model.get('activationPeriodAmountFieldId');
                rowData.activationPeriodAmountFieldName = this.model.get('activationPeriodAmountFieldName');
                rowData.activationPeriodUnitField = this.model.get('activationPeriodUnitField').toLowerCase();
                break;
            case '4':
                rowData.timeToDisplay = 'On a date taken from field ' + this.model.get('activationDateFieldName');
                rowData.activationDateFieldName = this.model.get('activationDateFieldName');
                rowData.activationDateField = this.model.get('activationDateField');
                break;
            case '5':
                rowData.timeToDisplay = constants.ITEM_EMPTY;
                rowData.activationDateExpression = JSON.stringify(this.model.get('activationDateExpression'));
                break;
            case '6':
                rowData.timeToDisplay = constants.ITEM_EMPTY;
                rowData.activationRecurisveEmailNumber = this.model.get('activationRecurisveEmailNumber');
                rowData.activationRecurisveEmailFrequency = this.model.get('activationRecurisveEmailFrequency').toLowerCase();
                break;
        }
        $(this.table).setRowData(id, rowData);
    }


    preupdateForm(){

        if (!this.model.get('activationPeriodAmountFieldId')) {
            this.model.set('activationPeriodAmountFieldName', '', {silent: true})
        } else {
            let name = ListService.determineFieldName(this.model.get('activationPeriodAmountFieldId'));
            this.model.set('activationPeriodAmountFieldName', name, {silent: true})
        }
        if (!this.model.get('activationPeriodUnitLiteral')) {
            this.model.set('activationPeriodUnitLiteral', 'minutes', {silent: true})
        }
        if (!this.model.get('activationPeriodUnitField')) {
            this.model.set('activationPeriodUnitField', 'days', {silent: true})
        }
        if (!this.model.get('activationRecurisveEmailFrequency')) {
            this.model.set('activationRecurisveEmailFrequency', 'weeks', {silent: true})
        }
        if (!this.model.get('activationDateField')) {
            this.model.set('activationDateFieldName', '', {silent: true})
        } else {
            let name = ListService.determineFieldName(this.model.get('activationDateField'));
            this.model.set('activationDateFieldName', name, {silent: true})
        }
    }

    updateForm(){
        super.updateForm();

        if (this.model.get('activationType')) {
            $("input[name=activationType][value=" + this.model.get('activationType') + "]").prop('checked', true);
            this.activateFields('activationType', this.model.get('activationType'));
        }

        if ( this.model.get('cancelAllOthers') === true || this.model.get('cancelAllOthers') === 'true' ) {
            $("#cancelAllOthers").attr('checked', true);
        }
    }

    _injectDatePicker() {
        const $dp = $('#activationDate');
        var renderDate=this.model.get('activationDate') || new Date();
        let self=this;
        $dp.datepicker({
            showOn: "button",
            buttonImageOnly: true,
            buttonImage: require('common/icons/calendar.png'),
            'disabled': true,
            changeYear: true,
            changeMonth: true,
            gotoCurrent: true,
            defaultDate: renderDate,
            dateFormat: 'yy-mm-dd',
            beforeShow: function( opts ){
                setTimeout(function(){
                    $('.ui-datepicker').css('z-index', constants.Z_INDEX_CALENDAR);
                }, 0);
            }
        });
        return this;
    }


    render() {
        this.preupdateForm();
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));

        this._injectDatePicker();
        this.resetFields();
        this.updateForm();
        return this;

    }
}

export default EditNotificationTimeView;
